import { ModuleContent } from '../contract';

/**
 * Content for the Form container module.
 * The form itself is a separate server-side entity linked via formKey (GUID).
 * This content type stores the module-level display settings.
 */
export type FormModuleContent = {
	formKey: string;
	buttonText: string;
	preSubmitText: string;
	postSubmitText: string;
};

export function isFormModuleContent(content: ModuleContent): content is FormModuleContent {
	return typeof (content as FormModuleContent).formKey === 'string';
}
